import apiFetch from '../apiFetch'
export default function (dossierStageId, token, body) {
  return apiFetch({ endPoint: `conditionNoDocumental/All/Data/${dossierStageId}`, method: 'POST', body: body, token: token })
}
